import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import { UpdatePublisherContainer } from 'features/inventory/publisher/containers/UpdatePublisherContainer/UpdatePublisherContainer';
import { History } from 'history';
import {
  PublisherLegacy,
  usePublisherLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';

export interface IUpdatePublisherPageProps {
  history: History;
  match: {
    params: {
      publisherId: string;
    };
  };
}

const UpdatePublisherPage = ({ history, match }: IUpdatePublisherPageProps) => {
  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();

  const { loading, data } = usePublisherLegacyQuery({
    variables: {
      id: match.params.publisherId,
      territories: [activeTerritory!],
    },
    errorPolicy: 'all',
  });

  if (!loading && !data?.publisherLegacy)
    return <Redirecting history={history} />;

  return (
    <main>
      <Container>
        <h1 className="sr-only">Update Publisher</h1>
        {loading ? (
          <Loader />
        ) : (
          <UpdatePublisherContainer
            history={history}
            match={match}
            publisher={data?.publisherLegacy as PublisherLegacy}
          />
        )}
      </Container>
    </main>
  );
};

export default UpdatePublisherPage;
